import { toRefs, computed } from 'vue';
import { getRotationDegree } from './component-lib.esm3.js';
import { useTheme } from '../../compositions/component-lib.esm3.js';
import { getThemeColor } from '../../styles/theme/component-lib.esm.js';

//
const SvgIconProps = {
  title: String,
  viewBox: String,
  size: {
    type: String,
    default: 'inherit'
  },
  color: {
    type: String,
    default: 'current'
  },
  /**
   * Allows you to dictate what direction the icon faces.  Note that
   * a rotation of 0 deg is considered down.  This property won't make
   * sense to use with every icon.
   * @default 'down'
   */
  direction: {
    type: String,
    default: 'down'
  },
  /**
   * The direction that a particular icon naturally points before
   * any transformation is applied.  This will be used to map
   * the `direction` passed in by the user so that when the user
   * specifies "left", the icon actually points left, regardless of
   * which way it naturally points.
   */
  naturalDirection: String
};
const ICON_SIZES = {
  small: 14,
  medium: 24,
  large: 34,
  xlarge: 44,
  xxlarge: 54
};

/**
 * A flexible, theme-able, SVG icon component with
 * accessibility built in.
 */
var script = {
  name: 'SvgIcon',
  props: SvgIconProps,
  setup(props) {
    const {
      color,
      size,
      direction
    } = toRefs(props);
    const theme = useTheme();
    const styles = computed(() => {
      return {
        '--icon-color': getThemeColor(color.value, theme.value),
        '--icon-size': ICON_SIZES[size.value] ? `${ICON_SIZES[size.value]}px` : size.value,
        '--icon-rotate': `rotate(${getRotationDegree(direction.value)}deg)`
      };
    });
    return {
      styles
    };
  }
};
export { ICON_SIZES, SvgIconProps, script as default };